import { gql, useQuery } from "@apollo/client";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  Legend,
} from "recharts";
import Card from "components/base/Card";
import DateRangeSlider from "components/base/DateRangeSlider";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useEffect, useState } from "react";

const FETCH_PRODUCTION_ISSUES = gql`
  query FETCH_PRODUCTION_ISSUES($years: Int!) {
    shipmentProductionIssues(years: $years) {
      year
      quarter
      ordersCount
      errorCount
      delayCount
    }
  }
`;

const ProductionIssues = () => {
  const [dateRange, setDateRange] = useState(null);
  const { loading, error, data } = useQuery(FETCH_PRODUCTION_ISSUES, {
    variables: { years: 3 },
  });

  useEffect(() => {
    if (data) {
      setDateRange([0, data.shipmentProductionIssues.length - 1]);
    }
  }, [data]);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const chartData = data.shipmentProductionIssues.map((item) => ({
    ...item,
    name: `${item.year} - Q${item.quarter}`,
  }));
  const activeDateRange = dateRange || [0, chartData.length - 1];
  const filteredData = chartData.slice(
    activeDateRange[0],
    activeDateRange[1] + 1,
  );

  return (
    <Card
      className="border-0 dark:border-0"
      title="Orders in Production, Errors and Delays"
    >
      <ResponsiveContainer className="mt-8" width="100%" height={200}>
        <BarChart
          data={filteredData}
          stackOffset="silhouette"
          margin={{ top: 20, right: 5, bottom: 0, left: 0 }}
        >
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip cursor={{ fill: "#f5f5f5" }} />
          <Legend />
          <Bar dataKey="ordersCount" fill="#4299E1" name="Orders">
            <LabelList dataKey="ordersCount" position="top" />
          </Bar>
          <Bar dataKey="errorCount" fill="#F6AD55" name="Errors">
            <LabelList dataKey="errorCount" position="top" />
          </Bar>
          <Bar dataKey="delayCount" fill="#FC8181" name="Delay">
            <LabelList dataKey="delayCount" position="top" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <DateRangeSlider
        key={chartData.length}
        min={0}
        max={chartData.length - 1}
        onChange={setDateRange}
      />
    </Card>
  );
};

export default ProductionIssues;
